import axios from "axios";

// Default to a same-origin "/api" so the same build works on every domain it is
// served from (websalon.in, bookmysaloon.com). Each domain's nginx proxies /api
// to the shared backend, which keeps the owner auth cookie first-party. Set
// REACT_APP_BACKEND_URL only to point a build at a different origin (e.g. local dev).
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
    baseURL: `${BACKEND}/api`,
    withCredentials: true,
});

export const API_BASE = `${BACKEND}/api`;
